<template>
  <footer class="download-footer flex bg-white fixed pin-x pin-b py-md">
    <div class="container">
      <div class="flex items-center justify-between">
        <h4 class="text-lg md:text-xl m-0">
          <span v-if="selected.length > 0">
            <strong>{{ selected.length }} {{ 'selected' | t }}</strong> of
          </span>
          {{ total }} {{ 'result' | t }}{{ total !== 1 ? 's' : '' }}
        </h4>
        <div class="flex" v-stack-x:sm>
          <slo-button v-if="selected.length > 0" fill="outline" @click="onCancel">
            {{ 'Cancel' | t }}
          </slo-button>
          <slo-button :disabled="selected.length === 0" @click="onDownload">
            <span v-if="!downloadState">Download</span>
            <span v-else-if="downloadState === 'loading'">{{ 'Downloading...' | t }}</span>
            <span v-else-if="downloadState === 'success'">{{ 'Downloaded!' | t }}</span>
            <span v-else-if="downloadState === 'error'">{{ 'Download failed.' | t }}</span>
          </slo-button>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
// needed to polyfill promise
import axios from 'axios';
import SloButton from '../../../lib/components/SloButton.vue';
import t from '../../main/i18n';

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
export default {
  components: {
    SloButton
  },
  props: {
    total: {type: Number, required: true},
    selected: {type: Array, required: true}
  },
  data() {
    return {
      downloadState: null
    };
  },
  filters: {
    t
  },
  methods: {
    onCancel() {
      this.$emit('clear');
    },
    async onDownload() {
      const mids = this.selected;
      this.downloadState = 'loading';
      try {
        const {
          data: {path}
        } = await axios.post(
          window.location.origin + '/rendering-repository/package',
          {mids},
          {
            headers: {
              'content-type': 'application/json; charset=utf-8'
            }
          }
        );
        this.downloadFile(path);
        this.downloadState = 'success';
        await sleep(1500);
        this.downloadState = null;
      } catch (e) {
        this.downloadState = 'error';
        await sleep(2000);
        this.downloadState = null;
      }
      this.$emit('clear');
    },
    async downloadFile(file) {
      const a = document.createElement('a');
      a.href = file;
      a.download = '';
      a.addEventListener('click', event => {
        event.stopPropagation();
        a.remove();
      });
      document.body.appendChild(a);
      a.click();
    }
  }
};
</script>

<style lang="scss" scoped>
.download-footer {
  z-index: 1031;
  box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.04), 0 -4px 24px 0 rgba(0, 0, 0, 0.01);
}
</style>
